import GalleryComponent from './gallery.vue';

export default {
    install (_Vue) {
        const GalleryConstructor = _Vue.extend(GalleryComponent) 
        const instance = new GalleryConstructor({
            el : document.createElement('div')
        })
        document.body.appendChild(instance.$el)
        _Vue.prototype.$gallery = (selector) => {
            instance.init(selector);
        }
        _Vue.prototype.$gallerySwipe = (func) => {
          instance.initBySwipe(func)
        }
    }
}



// WEBPACK FOOTER //
// ./src/plugins/gallery.js